import { FC } from 'react';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage } from 'react-intl';

import useMedia from 'src/hooks/useMedia';
import trns from './trns';

const phone = 'shared/phone.svg';
const icon = 'shared/check.svg';

export const aboutUsContainerId = 'about-us-container';

const listGoals = [
  {
    id: 1,
    text: <FormattedMessage {...trns.aboutUsGoal1} />
  },
  {
    id: 2,
    text: <FormattedMessage {...trns.aboutUsGoal2} />
  },
  {
    id: 3,
    text: <FormattedMessage {...trns.aboutUsGoal3} />
  }
];

const AboutUsContainer: FC = () => {
  const { m } = useMedia();
  return (
    <div
      className={cn('hidden m:flex m:w-full m:relative m:py-10')}
      id={aboutUsContainerId}
    >
      <Constraints className="w-full">
        <div className="flex flex-col w-full items-center justify-center">
          <div
            className={cn(
              'flex mt-9 px-5 flex-col-reverse',
              'm:mt-12 m:flex-row sm:mt-12 sm:flex-row xl:px-0'
            )}
          >
            {m && (
              <div
                className={cn(
                  'block w-3/5 mx-auto mt-10',
                  'sm:my-0 sm:mx-0 m:w-1/4'
                )}
              >
                <NextImage
                  alt="phone"
                  src={phone}
                  layout="fixed"
                  height={400}
                  width={205}
                  priority
                />
              </div>
            )}
            <div
              className={cn(
                'flex flex-col items-start justify-center w-full font-light',
                'm:pl-24 sm:w-3/4'
              )}
            >
              <h2 className="uppercase text-astronautBlue fs-header4-bold text-center mb-14">
                <FormattedMessage {...trns.aboutUsTitle} />
              </h2>
              <p className="mb-2.5 text-astronautBlue fs-body-bold">
                <FormattedMessage {...trns.aboutUsGoal} />
              </p>
              {listGoals.map((item) => {
                return (
                  <div className="flex items-start" key={item.id}>
                    <div className="relative">
                      <NextImage
                        alt="check"
                        src={icon}
                        layout="fixed"
                        height={16}
                        width={22}
                      />
                    </div>
                    <div className="ml-5">{item.text}</div>
                  </div>
                );
              })}
              <p className="my-2.5">
                <FormattedMessage {...trns.aboutUsDescription1} />
              </p>
              <p className="my-2.5">
                <FormattedMessage {...trns.aboutUsDescription2} />
              </p>
            </div>
          </div>
        </div>
      </Constraints>
    </div>
  );
};

export default AboutUsContainer;
